import React, { useEffect, useState } from "react";
import { Button } from "../Button/Button";
import { HeroInternas } from "../heroInternas/HeroInternas";
import axios from "axios";
import getDate from "../../../../../helpers/getDate";

export const ActoDeAdjudicacion = () => {
    const [acto, setacto] = useState("");
    const [acto_mes, setactomes] = useState("");
    const [acto_anio, setactoanio] = useState("");
    const [isPdfEnabled, setIsPdfEnabled] = useState(false);

    let newdate = new Date();
    let date = getDate(newdate);
    let anio = newdate.getFullYear();
    let month = newdate.getMonth() + 1;

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch endpoint details
                const endpoint = await (await fetch('/api/show_endpoints/wsproximoacto')).json();

                // Fetch acto data
                const response = await fetch(
                    `${endpoint.url_base}${endpoint.url_variable}`,
                    {
                        cache: "no-cache"
                    }
                );
                const json = await response.json();
                let lote = json[0].Lote.toString();
                setactoanio(lote.slice(0, 4));
                setactomes(lote.slice(-2));
                setacto(json[0]);
            } catch (error) {
                console.error("Error fetching acto data:", error);
            }
        };

        const checkPdfEnabled = async () => {
            try {
                const response = await fetch('/check_pdf_adjudicacion_enabled');
                const data = await response.json();
                const isEnabled = Boolean(Number(data.haberNetoEnabled)); // Convert "1" or "0" to boolean
                console.log("Is PDF Enabled:", isEnabled); // Log the boolean value for debugging
                setIsPdfEnabled(isEnabled);
            } catch (error) {
                console.error('Error checking PDF adjudication status:', error);
            }
        };


        fetchData();
        checkPdfEnabled();
    }, []);

    let buttonsLast5Years = [];

    for (let index = 0; index < (month === 12 ? 5 : 6); index++) {
        buttonsLast5Years.push(
            <Button
                key={index}
                className="btn-acto"
                link={`/acto_de_adjudicacion/resultados_por_mes/${
                    anio - index
                }`}
                img="/images/icons/plus.svg"
                imgHover="/images/icons/plus-vino.svg"
                text={anio - index}
            />
        );
    }

    const monthNames = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
    ];

    const [yearr, monthh, day] = acto?.FechaDelActo?.split("-") ?? [];
    const fecha = `${monthNames[+monthh - 3]} ${yearr}`;
    return (
        <>
            <HeroInternas
                title="Acto de adjudicacion"
                clase="acto"
                img="/images/internas/acto-desktop.png"
                imgMobile="/images/internas/acto-mobile.png"
            />
            <div>
                <div className="actoDeAdjudicacion">
                    <div className="actoDeAdjudicacion--container">
                        {Object.values(acto).length !== 0 ? (
                            <>
                                {acto.ErrorCodigo === "00" ? (
                                    <div className="actoDeAdjudicacion--div">
                                        <h1>PRÓXIMO ACTO</h1>
                                        <div className="actoDeAdjudicacion--div--innerDivText">
                                            <div>
                                                <h2>Fecha:</h2>
                                                <p>{acto.FechaDelActo}</p>
                                                <h2>
                                                    CORRESPONDIENTE A FONDOS DE:{" "}
                                                </h2>
                                                <p>{acto_mes}-{acto_anio}</p>
                                                <h2>Grupos Participantes:</h2>
                                                <p>
                                                    {acto.GrupoDesde} a{" "}
                                                    {acto.GrupoHasta}
                                                </p>
                                                {isPdfEnabled && (
                                                    <a
                                                        className="btn-heroHome"
                                                        href={`/get_pdf_adjudicacion?timestamp=${Date.now()}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <button>
                                                            Listado de grupos participantes
                                                        </button>
                                                    </a>
                                                )}
                                            </div>
                                            <div>
                                                <h2>APERTURA DEL ACTO:</h2>
                                                <p>8:30 am</p>
                                                <h2>
                                                    CIERRE DE RECEPCIÓN DE
                                                    OFERTAS DE LICITACIÓN:
                                                </h2>
                                                <p>8:35 am</p>
                                                <h2>ACTO EN VIVO:</h2>
                                                {acto.Link && acto.Link !== "" ? (
                                                    <a
                                                        className="btn-heroHome"
                                                        target="_blank"
                                                        href={acto.Link}
                                                    >
                                                        <button>
                                                            Click para ver el acto
                                                        </button>
                                                    </a>
                                                ) : (
                                                    "No disponible"
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <p>Aún no hay información sobre el próximo acto</p>
                                )}
                            </>
                        ) : (
                            <div className="d-flex justify-content-center">
                                <div
                                    className="spinner-border text-amarillo mb-half"
                                    role="status"
                                >
                                </div>
                            </div>
                        )}
                        <div className="separator--hor my-half mb-octa"></div>
                        <div className="actoDeAdjudicacion--div">
                            <h1>RESULTADOS POR MES</h1>
                            <div className="actoDeAdjudicacion--div--innerDiv">
                                {buttonsLast5Years}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
